import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getExtricationSelector } from '../../procedures/extrication/selectors'
import { IExtricationState } from '../../procedures/extrication/store/extrication.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addExtricationItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const extricationState: IExtricationState = yield select(getExtricationSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const {
    pta,
    method,
    addToTimeline,
    key,
    time,
    date,
    assessedBy,
    attempts,
    successfulAttempt,
    comments,
    isEkgImport,
  } = extricationState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.EXTRICATION_PROCEDURE,
      method?.name || '',
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const successfulAttemptLabel = successfulAttempt ? 'Yes' : 'No'
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Extrication',
      eventSubHeader: `By ${
        assessedBy?.name || ''
      }, Attempts: ${attempts}, Success: ${successfulAttemptLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_EXTRICATION_PROCEDURE_ITEM,
      defaultHref: TabConstants.EXTRICATION_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addExtricationItemSaga() {
  yield takeLatest([TimelineConstants.ADD_EXTRICATION_ITEM], addExtricationItem)
}
